// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"footer-module--wrapper--3L7H9"};